// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MuiSvgIcon-root{
    color: #fff !important;
}
.MuiButtonBase-root.dataTableButton{
 display: flex;
 justify-content: center;
 align-items: center;
 gap: 10px;
}`, "",{"version":3,"sources":["webpack://./src/components/DataTable/DataTable.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;AAC1B;AACA;CACC,aAAa;CACb,uBAAuB;CACvB,mBAAmB;CACnB,SAAS;AACV","sourcesContent":[".MuiSvgIcon-root{\n    color: #fff !important;\n}\n.MuiButtonBase-root.dataTableButton{\n display: flex;\n justify-content: center;\n align-items: center;\n gap: 10px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
